import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { AuService } from '../../au/au.service';
import { EditorComponent } from 'src/app/editor/editor.component';
import { AddMapCapaComponent } from '../../add-map-capa/add-map-capa.component';
import { MatSelect } from '@angular/material/select';
@Component({
  selector: 'app-parallel-workflow-findings',
  templateUrl: './parallel-workflow-findings.component.html',
  styleUrls: ['./parallel-workflow-findings.component.scss']
})
export class ParallelWorkflowFindingsComponent implements OnInit {
  isProcessing = false;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  oneQmsUsersDataForTable1: any = [];
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  oneQmsUsersDataForTable1Temp: any;
  dataTypeList: any = [];
  array: any = [];
  oneQmsOrgUsersDetails: any;
  searchText: any;

  codelistGroupList: any = [];
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  oneQmsUsersDataForFilter !: any[];
  dropDownDataForModule: any = [];
  makeStickyColumns: any;
  dropDownForDesignationCode: any;
  searchByReviewByUser: any;
  ReviewByUserDropdown: any = [];
  visibleactionperfrom: boolean;
  listOfUsers: any;

  moduleNameForDropdown: any = [];
  documentTypeListDropdown: any = [];
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  };
  severityTxt: any;
  assignedToUserTxt: any;
  assignedToDepartmentTxt: any;
  capaGroupTxt: any;
  departmentCodeTxt: any;

  selectedSeverity: any = [];
  selectedAssignedToUser: any = [];
  selectedResponseReviewUser: any = [];
  selectedImplementationReviewerUser: any = [];
  selectedAssignedToDepartment: any = null;
  selectedCapaGroup: any = null;

  dropDownForSeverity: any = [];
  dropDownForAssignedToUser: any = [];
  dropDownForDepartmentCode: any = [];
  dropDownForCapaGroup: any = [];

  severityDropdown: any = [];
  assignedToUserDropDown: any = [];
  departmentCodeDropdown: any = [];
  capaGroupDropDown: any = [];
  showFindingAddBtn: boolean = false;
  tableName: any;

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, public qmsservice: qmsService, private readonly elem: ElementRef,
    public auService: AuService) {
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

  }

  ngOnInit(): void {
    this.message.isfindingsFrom = "PWF";
    this.dropDownForRequestedAt = JSON.parse(sessionStorage.getItem('dropDownForRequestedAt') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.appService.getOneQmsUsersWithRolesVwDetails("QMS").subscribe((response: any) => {
      for (const element of response) {
        element.isActive = element.isActive == "Y";
      }
      this.listOfUsers = response;
      this.listOfUsers = this.listOfUsers.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      this.selectBoxeForUserList();
      this.isProcessing = false;
    });
    this.appService.getQmsBusinessAreasByModule(this.qmsservice.moduleName).subscribe((data: any) => {

      this.getQmsBusinessAreaDetail = data;
      this.filteredRequestedAtValue = this.getQmsBusinessAreaDetail;
      this.selectBoxeForRequestedAt();
    });

    const activityId = this.message.activityId;

    this.appService.getGroupsModuleCurrentUserVw("CAPA").subscribe((data: any) => {
      this.dropDownForCapaGroup = data;
      this.selectBoxForCapaGroup();
    });

    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxForDepartmentCode();

    this.appService.getCodeListsByGroup("SEVERITY").subscribe((data: any) => {
      this.dropDownForSeverity = data;
      this.selectBoxForSeverity();
    });

    this.appService.getAuParticipantsByAuNo(activityId).subscribe((data: any) => {
      this.dropDownForAssignedToUser = data;
      this.selectBoxForResponsibilityUserList();
      this.isProcessing = false;
    });

    this.appService.getQmsBusinessAreasByModule(this.qmsservice.moduleName).subscribe((businessArea: any) => {
      this.requestedAtList = businessArea ?? [];
      this.requestedAtList && this.selectBoxForRequestedAt();
    })
    this.visibleDataGrid = false;
    this.getcallMethod();
  }
  selectBoxForCapaGroup() {
    this.capaGroupDropDown = this.dropDownForCapaGroup?.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    }));
  }

  selectBoxForDepartmentCode() {
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  selectBoxForSeverity() {
    this.severityDropdown = this.dropDownForSeverity?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }


  getcallMethod() {
    setTimeout(() => {


      this.isProcessing = true;
      this.oneQmsUsersDataForTable1 = [];
      const data = {

        gridName: "PARALLEL_WORKFLOW_FINDINGS"
      }
      this.appService.getDynamicGridHeaders(data).subscribe({
        next: (response: any) => {
          response.orderByClause ??= "";
          this.makeStickyColumns = response.fixedFieldCnt;
          this.tableName = response.tableOrViewName;
          const data1: any = {

            gridName: "PARALLEL_WORKFLOW_FINDINGS",
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn == null ? "" : "AU_NO,ASSIGNED_TO_USER," + response.invisibleColumn,
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            codelistGroup: null,
            manualEntryDataFields: response.manualEntryDataFields,
            workflowId: this.qmsservice.workflowId,
            clobColumnlist: response.closblist || "",
            blobColumnlist: response.bloblist || ""
          }
          this.reportObj = { ...data, ...data1 };
          this.labelcall();
          this.appService.getDynamicGridData(data1).subscribe({
            next: (response1: any) => {
              this.oneQmsUsersDataForTable1 = response1;
              this.visibleAuditTrail = false;
              data1.columnsListarray = data1.columnsList.split(",");
              data1.fieldColumnarray = data1.fieldLabelsList.split(",");
              data1.invisibleColumnarray = data1.invisibleColumn.split(",");
              data1.fieldSizeListArray = data1.fieldSizeList.split(",");
              this.columnLists.columnsListarray = data1.columnsListarray;
              this.columnLists.fieldLabelsList = data1.fieldLabelsList;
              this.columnLists.fieldColumnarray = [];
              for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                this.columnLists.fieldColumnarray.push({
                  "fieldColumnarray": data1.fieldColumnarray[p],
                  "width": data1.fieldSizeListArray[p] + 'px'
                })
              }
              this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
              this.columnLists.fieldSizeListArray = [];
              for (const element of data1.fieldSizeListArray) {
                this.columnLists.fieldSizeListArray.push(element + 'px');
              }
              for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
                for (const element of this.columnLists.invisibleColumnarray) {
                  if (this.columnLists.columnsListarray[y] == element) {
                    this.columnLists.columnsListarray.splice(y, 1);
                    this.columnLists.fieldColumnarray.splice(y, 1);
                    this.columnLists.fieldSizeListArray.splice(y, 1);
                  }
                }
              }
              let tableData = {
                tablename: data1.tableOrViewName
              };
              this.columnLists.columnsListarray1 = [];
              this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const element of this.oneQmsUsersDataForTable1) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType == 'CHECKBOX') {
                      element[dataType.columnName] = element[dataType.columnName] == "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
                this.visibleDataGrid = true;
              });

              this.message.gridList = this.oneQmsUsersDataForTable1;
              this.collectionSize = this.oneQmsUsersDataForTable1.length;
              this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1.length / this.itemsPerPage);
            }, error: (error: any) => {
              this.visibleDataGrid = true;
              this.isProcessing = false;
              throw error;
            }
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }, 0);
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.oneQmsUsersDataForTable1.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1.length, page, this.perPage, targetpage);
    this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.oneQmsUsersDataForTable1.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.oneQmsUsersDataForTable1) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.oneQmsUsersDataForTable1) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.oneQmsUsersDataForTable1[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;

    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.oneQmsUsersDataForTable1.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  }

  /* End Multi Row Select */
  visibleAuditTrail: any;
  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;
  searchManagerDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = true;
      }
    } else {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = false;
      }
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  };

  onClick(event: any) {
  }

  onlinkClick(event: any) {
    console.log();
  }

  addworkflow: any;
  requestedAtTxt: any;
  refreshGridData() {
    this.visibleDataGrid = false;
    this.getcallMethod();
  };

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };
  popupTitle: any;
  parallelWorkflowActionObj: any = {};

  focusSearch(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  };

  callSelectBoxValues() {
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
    this.selectBoxeForRequestedAt();
  }

  selectBoxeForDesignationCode() {
    this.designationCodeDropdown = this.dropDownForDesignationCode.map((designation: any) => ({
      valueExp: designation.codelistCode,
      displayExp: designation.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  selectBoxeForUserList() {
    this.listOfUsersDropdown = this.listOfUsers.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  };

  selectBoxeForDepartmentCode() {
    this.departmentCodeDropdown = this.dropDownForDepartmentCode.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  selectBoxeForRequestedAt() {
    this.RequestedAtDropdown = this.filteredRequestedAtValue.map((requested_at: any) => ({
      valueExp: requested_at.taskRequestedAt,
      displayExp: requested_at.taskRequestedAt
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  coreBusinessAreaNameSelected: any;
  openAddPopup() {
    this.parallelWorkflowActionObj = {};
    this.addworkflow = true;
    this.searchingByRequestedAt = null;
    this.coreBusinessAreaNameValue = [];
    this.coreBusinessAreaNameDropdown = [];
    this.searchingByAssignedUser = null;
    this.searchByDepartmentCode = null;
    this.visibleEditButton = false;
    this.bussinessAreaName = '';
    this.qmsservice.getQmsActionDataUsingById = {};
    this.coreBusinessAreaNameSelected = false;
    this.operationFlag = 'ADD';
    this.findingsData = {}
    this.operationFlag = 'ADD';
    this.popupTitle = "Create Audit Findings";
    this.selectedTabName = "Create CAPA";
    this.visibleEditButton = false;
    this.selectedMainTabName = "Audit Finding Details";
    this.auService.finalRiskScore = null;
    this.auService.finalRiskStatus = null;
    [
      this.findingsData.finding,
      this.findingsData.reference,
      this.findingsData.deliverables,
      this.findingsData.auditorComments,
      this.findingsData.assignedToUserDetails,
      this.findingsData.findingShortDescription,
      this.findingsData.additionalField
    ] = new Array(7).fill("");

    [
      this.selectedResponseReviewUser,
      this.selectedImplementationReviewerUser,
    ] = new Array(3).fill([]);
    this.findingsData.responseReviewedByUser = null;
    this.findingsData.implementationReviewedByUser = null;
    this.findingsData.isCapaRequired = false;
    this.findingsData.capaNo = null;
    this.selectedSeverity = null;
    this.selectedAssignedToUser = null;
    this.selectedAssignedToDepartment = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  };

  searchingByRequestedAt: any = [];
  coreBusinessAreaNameValue: any = [];
  searchingByAssignedUser: any = null;
  visibleEditButton: boolean;
  actionNameFieldValue: any;
  activityAtFieldValue: any;
  coreBusinessAreaNameValueFieldValue: any;
  descriptionFieldValue: any;
  assignedToFieldValue: any;
  targetDateToFieldValue: any;
  performedActionDetailsFieldValue: any;
  getQmsBusinessAreaDetail: any;
  filteredRequestedAtValue: any;
  filteredBusinessAreaValue: any;
  coreBusinessAreaNameDropdown: any = [];
  selectCoreBusinessAreaNameValueExp: any = [];
  bussinessAreaName: string = "";
  dropDownForRequestedAt: any;
  isAdenabled: boolean = false;
  coreBusinessAreaNameTxt: any;
  assignedUserTxt: any;
  RequestedAtDropdown: any = [];
  listOfUsersDropdown: any;
  searchByDepartmentCode: any = null;
  selectedDepartmentValue: any;
  selectedDesignationValue: any;
  designationCodeDropdown: any = [];

  findingsData: any = {};
  operationFlag: any;
  getColor(status: any) {
    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      return 'red';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      return 'orange';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      return 'green';
    } else {
      return '';
    }
  };
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };
  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  datePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    adaptivePosition: true,
    minDate: new Date()
  }

  closureDateDisableFlag: boolean = false;
  onSeveritySelect(event: any, item: any) {
    const groupId = this.qmsservice.selectedActivityGroupId;
    const groupDetailId = this.qmsservice.selectedGroupDetailData.groupDetailId;
    if (event.isUserInput) {
      this.handleDropDownValidation('severity-validation', item.valueExp);

      this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId).subscribe((response: any) => {
        for (const element of response) {
          if (element.type == ("Findings-" + item.displayExp)) {
            if (element.toBeClosedInDays) {
              this.findingsData.expectedClosureDate = null;
              this.closureDateDisableFlag = true;
            } else {
              this.closureDateDisableFlag = false;
            }
          }
        }
      });
    }

  }

  onSeverityDeSelect() {
    this.handleDropDownValidation('severity-validation', this.selectedSeverity);
  }

  selectBoxForResponsibilityUserList() {
    this.assignedToUserDropDown = this.dropDownForAssignedToUser?.filter((item: any) => item.applicationUserId !== null)
      ?.map((item: any) => ({
        valueExp: item.applicationUserId,
        displayExp: item.userName
      }));
  }

  onAssignToUserSelect(event: any, item: any) {
    setTimeout(() => {
      if (event.isUserInput) {
        this.handleDropDownValidation('assign-to-user-validation', this.selectedAssignedToUser);
      }
    }, 0)
  }

  onAssignToUserDeSelect() {
    this.handleDropDownValidation('assign-to-user-validation', this.selectedAssignedToUser);
  }
  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field && (field.style.color = selectedItems == null && field ? 'red' : '');
  }

  async validateAudit(): Promise<void> {

    const validations = [
      { condition: !this.findingsData.finding, id: 'finding-validation' },
      { condition: !this.findingsData.reference, id: 'reference-validation' },
      { condition: this.selectedSeverity == null, id: 'severity-validation' },
      { condition: this.selectedAssignedToUser == null, id: 'assign-to-user-validation' },
      { condition: !this.findingsData.findingShortDescription, id: 'finding-short-description-validation' },
      { condition: this.findingsData.isCapaRequired && !this.findingsData.capaNo, id: 'capaActivity-validation' },
      { condition: (this.businessAreaDropdown.length ? !this.selectedBusinessArea.length : !this.findingsData.coreBusinessAreaName) && this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && this.findingsData.requestedAt, id: 'business-area' },
    ]
    await this.handleAsyncValidation(validations);
  }

  private async handleAsyncValidation(validations: { condition: boolean, id: string }[]): Promise<void> {
    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);
    this.validatedFindingArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed')
    if (invalidIds.length > 0) {
      this.manageValidations(invalidIds);
    }
  }

  manageValidations(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    })
  }
  editorValue: any;
  textareaEditorTitle: any;
  @ViewChild('capaPopup', { static: true }) capaPopup: TemplateRef<any>;
  visibleCapaPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('angularEditorTextarea', { static: true }) angularEditorTextarea: TemplateRef<any>;
  visibleangularEditorTextareaPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchCapaRequired', { static: true }) searchCapaRequired: TemplateRef<any>;
  visibleSearchCapaRequiredPopup: MatDialogRef<TemplateRef<any>>;
  openEditor(value: string) {
    this.editorValue = "";
    this.textareaEditorTitle = "";
    this.textareaEditorTitle = value;
    const formattedValue = value
      .split(' ')
      .map((word, index) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
    this.editorValue = this.findingsData[formattedValue] || '';
    this.textareaEditorTitle = value;
    this.visibleangularEditorTextareaPopup = this.dialog.open(this.angularEditorTextarea, this.angularEditorTextareaConfig);
  };
  okAngularEditorData(editorValue: any) {
    const formattedTitle = this.textareaEditorTitle
      .split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
    this.findingsData[formattedTitle] = this.editorValue;
    this.visibleangularEditorTextareaPopup.close();
  }
  cancelAngularEditorData() {
    this.visibleangularEditorTextareaPopup.close();
  }
  editingFindingId: any;
  openEditPopup(list: any, idx: any) {
    if (idx == 0) {
      this.auService.finalRiskScore = null;
      this.auService.finalRiskStatus = null;
      this.operationFlag = 'EDIT';
      this.auService.ParallelWorkflowfindingId = this.editingFindingId = list.FINDING_ID;
      this.selectedMainTabName = "Audit Finding Details";
      this.appService.getFindingsWorkflowByWorkflowIdFindingId(this.qmsservice.workflowId, this.editingFindingId).subscribe((data: any) => {
        this.popupTitle = "Update Findings";
        this.selectedSeverity = data[0].severity;
        this.selectedAssignedToUser = data[0].assignedToUser;
        this.selectedAssignedToDepartment = data[0].assignedToDepartment;
        this.selectedAssignedToDepartment = data[0].assignedToDepartment;
        this.auService.finalRiskScore = data[0].finalRiskScore;
        this.auService.finalRiskStatus = data[0].finalRiskStatus;
        data[0].isCapaRequired = data[0].isCapaRequired == 'Y';
        data[0].expectedClosureDate = data[0].expectedClosureDate == null ? null : new Date(data[0].expectedClosureDate);
        data[0].dueDate = data[0].dueDate == null ? null : new Date(data[0].dueDate);
        this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && this.onRequestedAtSelect(this.event, { valueExp: data[0].requestedAt, displayExp: data[0].requestedAt });

        setTimeout(() => {
          if (this.businessAreaDropdown.length) {
            this.selectedBusinessArea = data[0].coreBusinessAreaName.split(',');
            this.isAllBusinessAreaSelected = this.selectedBusinessArea.length == this.businessAreaDropdown.length;
          } else {
            [this.selectedBusinessArea, this.isAllBusinessAreaSelected] = [[], false];
          }
        }, 1500)

        this.findingsData = data[0];
        this.visibleEditButton = true;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        this.isProcessing = false;
      });

    }
  };
  cancelAddAndEditFunction() {
    this.qmsservice.moduleName = "AU";
    this.visibleAddAndEditPopup.close();
  };
  validatedFindingArray: any = [];
  addAndEditFunction(findingsData: any) {
    return new Promise<boolean>((resolve) => {
      let validationPromises: Promise<void>[] = [];
      this.validatedFindingArray = [];
      validationPromises.push(this.validateAudit());
      Promise.all(validationPromises)
        .then(() => {
          const isValid = !this.validatedFindingArray.includes('Failed');
          if (isValid) {
            this.isProcessing = true;

            let businessArea = null;
            if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y') {
              businessArea = this.businessAreaDropdown.length ? this.selectedBusinessArea?.join(',') : this.findingsData?.coreBusinessAreaName ?? null;
            }

            let data = {
              auNo: this.message.activityId,
              seq: findingsData.seq,
              findingShortDescription: findingsData.findingShortDescription,
              finding: findingsData.finding,
              severity: this.selectedSeverity ?? null,
              dueDate: findingsData.dueDate ? new Date(findingsData.dueDate) : null,
              deliverables: findingsData.deliverables,
              assignedToUser: this.selectedAssignedToUser ?? null,
              assignedToDepartment: this.selectedAssignedToDepartment ?? null,
              assignedToUserDetails: findingsData.assignedToUserDetails,
              completedOn: '',
              isCapaRequired: findingsData.isCapaRequired ? "Y" : "N",
              capaNo: findingsData.isCapaRequired ? findingsData.capaNo : null,
              reference: findingsData.reference,
              comments: findingsData.comments,
              auditorComments: findingsData.auditorComments,
              finalRiskScore: findingsData.finalRiskScore,
              finalRiskStatus: findingsData.finalRiskStatus,
              expectedClosureDate: findingsData.expectedClosureDate ? new Date(findingsData.expectedClosureDate) : null,
              responseReviewedByUser: null,
              implementationReviewedByUser: null,
              workflowId: this.qmsservice.workflowId,
              additionalField: findingsData.additionalField,
              requestedAt: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : findingsData.requestedAt,
              coreBusinessAreaName: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : businessArea,
            }
            if (this.selectedResponseReviewUser != undefined) {
              if (this.findingsData.responseReviewedByUser == 0) {
                data.responseReviewedByUser = this.findingsData.responseReviewedByUser;
              } else if (this.selectedResponseReviewUser) {
                data.responseReviewedByUser = this.selectedResponseReviewUser;
              }
            }
            if (this.selectedImplementationReviewerUser != undefined) {
              if (this.findingsData.implementationReviewedByUser == 0) {
                data.implementationReviewedByUser = this.findingsData.implementationReviewedByUser;
              } else if (this.selectedImplementationReviewerUser) {
                data.implementationReviewedByUser = this.selectedImplementationReviewerUser;
              }
            }
            if (this.operationFlag == 'ADD') {
              this.appService.createParallelWorkflowFindings(data).subscribe({
                next: (Response: any) => {
                  if (Response.resultType == "S") {
                    this.reload();
                    this.visibleAddAndEditPopup.close();
                    this.isProcessing = false;
                    this.refreshGridData();
                    this.showSnackBar(Response.result, Response.resultType);
                  } else {
                    this.showSnackBar(Response.result, Response.resultType);
                    this.isProcessing = false;
                  }
                },
                error: (error) => {
                  this.isProcessing = false;
                  throw error;
                }
              });
            } else {
              delete findingsData.createdOn;
              delete findingsData.updatedOn;
              const modifiedData = {
                ...data,
                findingId: this.editingFindingId
              }
              this.appService.updateParallelWorkflowFindings(modifiedData).subscribe({
                next: (Response: any) => {
                  if (Response.resultType == "S") {
                    this.reload();
                    this.visibleAddAndEditPopup.close();
                    this.showSnackBar(Response.result, Response.resultType);
                  } else {
                    this.showSnackBar(Response.result, Response.resultType);
                    this.isProcessing = false;
                  }
                },
                error: (error) => {
                  this.isProcessing = false;
                  throw error;
                }
              });
            }
          } else {
            this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
          }
        }).catch((error) => {
          console.error('Error occurred during validation:', error);
          resolve(false);
        })
    })
  }
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }
  onIsCapaRequiredChecked(event: any) {
    if (!event.checked) {
      this.findingsData.capaNo = null;
    }
  }

  showUserSearchGrid: boolean;
  openSearchCapaRequiredPopup(event?: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.isPopupOpening) return;
    this.isPopupOpening = true;
    setTimeout(() => { this.isPopupOpening = false; }, 1000);

    this.qmsservice.tempselectedGroupDetailId = this.qmsservice.selectedGroupDetailId;
    this.qmsservice.tempactivitybuttonDetails = this.qmsservice.activity;
    this.qmsservice.isCapaTriggeredFromFindingPage = true;
    this.qmsservice.auFindings = true;
    this.selectedTabName = 'Create CAPA';

    if (this.findingsData.finding && this.findingsData.finding != '') {
      this.qmsservice.findingDetailsForCapaDescription = this.findingsData.finding;
    } else {
      this.qmsservice.findingDetailsForCapaDescription = '';
    }

    this.findingInfo = this.qmsservice.activity.auId + ' : ' + this.qmsservice.findingDetailsForCapaDescription;
    this.message.isFromFindings = true;

    setTimeout(() => {
      if (this.addMapCapaComponent) {
        this.addMapCapaComponent.openPopup();
      }
    }, 100);
  }

  onCapaEmitted() {
    const capa = this.message.addMapCapaFindings;
    if (capa) {
      this.findingsData.capaDetails = capa.capaId + '(' + capa.status + ')';
      this.findingsData.capaNo = capa.capaNo;
    }
    this.isProcessing = false;
    this.operationFlag == 'EDIT' && this.addAndEditFunction(this.findingsData);
  }

  selectedMainTabName: any;
  onTabClick1(event: any) {

    this.selectedMainTabName = event.tab.textLabel;

  }

  selectedTabName: any;
  onTabClick(event: any) {

    if (event.tab.textLabel == "Map CAPA") {
      this.showUserSearchGrid = false;
      this.selectedTabName = event.tab.textLabel;
    } else {
      this.selectedCapaGroup = null;
      this.searchByDepartmentCode = null;
      this.showUserSearchGrid = true;
      this.selectedTabName = event.tab.textLabel;
    }
  }

  auFindingsDataForGrid: any = [];
  auFindingsDataForGridTemp: any = [];
  getQmsCapaVwDetailsData: any = [];
  searchCapaRequiredGridDataFunction() {
    this.isProcessing = true;
    let data = {
      groupId: this.selectedCapaGroup ? this.selectedCapaGroup.toString() : null,
      deptCode: this.searchByDepartmentCode ?? null,
    };
    this.appService.searchCapa(data).subscribe((response: any) => {
      this.getQmsCapaVwDetailsData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchCapaRequiredGridDataFunction() {
    this.isProcessing = true;
    this.selectedCapaGroup = null;
    this.searchByDepartmentCode = null;
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  getCapaNo: any;
  getCapaTemp: any;
  privvalue: any;
  getCapaId: any;
  onCapaRequiredChange(event: any) {
    this.findingsData.capaNo = this.findingsData.capaId = this.findingsData.capaDetails = null;
  }


  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  workflowId: number = 0;
  actionId: any;
  refNo: any;
  deleteReason: any = null;
  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  deleteCodelist(deletingData: any) {
    this.popupTitle = "Delete Finding";
    this.workflowId = deletingData.WORKFLOW_ID;
    this.editingFindingId = deletingData.FINDING_ID;
    this.refNo = deletingData.REF_NO;
    this.deleteReason = null;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  reload() {
    this.qmsservice.moduleName = "AU" // triggerring component again
  }

  deleteFunction(deletingData: any) {
    if (this.deleteReason) {
      this.isProcessing = true;

      const deleting_obj = {
        workflowId: this.workflowId,
        findingId: this.editingFindingId,
        refNo: this.refNo,
        deleteReason: this.deleteReason,
      }

      this.appService.deleteParallelWorkflowFindings(deleting_obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleDataGrid = false;
            this.refreshGridData();
            this.reload();
            this.isProcessing = false;
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDelete() {
    this.visibleDeletePopup.close();
  }

  auditTrail: any = {};
  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  async openAuditTrail(viewType: any, finding: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : finding.FINDING_ID;
    this.auditTrail.viewType = viewType;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'PARALLEL_WORKFLOW_FINDINGS';
    /* Construct the report and popup name with fetched CLOB data */
    this.auditTrail.report_And_Popup_Name = `${this.qmsservice.moduleName} Parallel Workflow Findings Audit Trail [${this.qmsservice.activity.auId}${viewType === 'overAll' ? '' : ' - ' + finding.FINDING_SHORT_DESCRIPTION}]`;
    /* Trigger the dynamic audit trail component for 'overAll' viewType */
    viewType === 'overAll' && this.dynamicAuditTrailComponent.triggerTrail(finding);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};


  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + '  Parallel Workflow Findings Report [' + this.qmsservice.activity.auId + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall('PARALLEL_WORKFLOW_FINDINGS', this.tableName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.visibleDataGrid = false;
    this.getcallMethod();
  };

  @ViewChild('viwerClobPopup', { static: true }) viwerClobPopup: TemplateRef<any>;
  visibleviwerClobPopup: MatDialogRef<TemplateRef<any>>;
  aviwerlPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any, from: any): Promise<string | void> {
    return new Promise((resolve, reject) => {
      this.isProcessing = true;
      let docObj = {

        primeIdentifier: list.PRIM_IDENTIFIER,
        tableView: 'QMS_PARALLEL_WORKFLOW_FINDINGS_VW',
        columnName: columnName
      };

      this.htmlContent = "";

      this.appService.getClobToViewAudit(docObj).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;

          if (from === 'html') {
            /* If 'html', open editor and resolve with void (no return value) */
            this.htmlContent = Response.result;
            this.editorComponent.openEditor(this.htmlContent, columnName);
            resolve();/*  No specific value is returned here */
          } else {
            // If not 'html', return truncated result and trigger audit trail
            const result = Response.result.length > 20 ? Response.result.slice(0, 20) + '...' : Response.result;
            this.dynamicAuditTrailComponent.triggerTrail(list);
            resolve(result); // Resolve with the result
          }
        },
        error: (error: any) => {
          this.isProcessing = false;
          // Properly reject with an Error object
          reject(new Error(`Failed to fetch CLOB data: ${error.message || error}`));
        }
      });
    });
  }



  htmlContent: any;
  closeHtmlContent() {
    this.visibleviwerClobPopup.close();
  }

  findingInfo: any;
  isPopupOpening: boolean = false;
  @ViewChild(AddMapCapaComponent) addMapCapaComponent!: AddMapCapaComponent;

  public focusEmpty(): void {
    console.log();
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    let data = {
      gridName: this.reportObj.gridName,
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  infoIconSrc: string = 'src/assets/img/info-yellow.png';

  isRequestedAtOdd: any = null;
  requestedAtSearchText: string = '';
  businessAreaSearchText: string = '';
  requestedAtDropdown: any = [];
  requestedAtList: any = [];
  selectedBusinessArea: any = [];
  businessAreaList: any = [];
  businessAreaDropdown: any = [];

  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = this.requestedAtList?.filter((x: any) => x.module == 'AU')?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  public onRequestedAtSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('requested-at', item);

      if (item) {

        this.findingsData.requestedAtName = item.displayExp;
        const getBusinessArea = this.requestedAtList?.find((x: any) => x.taskRequestedAt == item.displayExp);
        [this.businessAreaList, this.selectedBusinessArea, this.findingsData.coreBusinessAreaName] = [[], [], null];
        this.businessAreaList = getBusinessArea?.listOfBusinessArea?.split(',');
        this.selectBoxForBusinessArea();

      } else {

        this.businessAreaList = [];
        this.businessAreaDropdown = [];
        this.findingsData.requestedAtName = '';
      }
    }
  }

  private selectBoxForBusinessArea(): void {
    this.businessAreaDropdown = this.businessAreaList?.map((bArea: any) => ({
      valueExp: bArea,
      displayExp: bArea
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  isAllBusinessAreaSelected?: boolean = false
  public onBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('business-area', this.selectedBusinessArea)
        this.isAllBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length;
      });
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  public toggleAllBusinessArea(): void {
    if (this.isAllBusinessAreaSelected) {
      for (const item of this.businessArea.options) item.select();
    } else {
      for (const item of this.businessArea.options) item.deselect();
      this.selectedBusinessArea = [];
    }

    setTimeout(() => { this.handleDropDownValidation('business-area', this.selectedBusinessArea); });
  }

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      4000: ['BUSINESS_AREA']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  public getTooltip(): string {
    return this.selectedBusinessArea.join(',');
  }


}
